import React from 'react';
import Navbar from '../components/Navbar';
import Headings from '../components/Headings';
import Slider from '../components/Slider';
import { bathroomsSlides } from '../data/data';
import InfoBlock from '../components/InfoBlock';
import CtaBanner from '../components/CtaBanner';
import Footer from '../components/Footer';

const Bathrooms = () => {
  return (
    <>
      <Navbar />
      <Headings headingName="Bathrooms" />
      <InfoBlock
        tagLine="Enhance Your Bathroom Experience with Us"
        simpleText="Discover unparalleled solutions tailored to perfection for your bathroom needs."
      />
      <Slider bathroomsSlides={bathroomsSlides} />
      <CtaBanner />
      <Footer />
    </>
  );
};

export default Bathrooms;
